import ServiceDetailsPageComponent from "./components/ServiceDetailsPageComponent";
import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";


import { addToCart } from "../redux/actions/cartActions";
import axios from 'axios'

const getServiceDetails = async(id) => {
    const { data } = await axios.get(`/api/services/get-one/${id}`);
    return data
}

const writeReviewApiRequest = async (serviceId, formInputs) => {
    const { data } = await axios.post(`/api/users/review/${serviceId}`, { ...formInputs });
    return data;
}

const ServiceDetailsPage = () => {

    const dispatch = useDispatch()

    const userInfo = useSelector((state) => state.userRegisterLogin.userInfo);


  return <ServiceDetailsPageComponent  addToCartReduxAction={addToCart} reduxDispatch={dispatch} getServiceDetails={getServiceDetails} userInfo={userInfo}  writeReviewApiRequest={writeReviewApiRequest} />;
};

export default ServiceDetailsPage;
